module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hans/5-29a7b459a88c478edd8c5acf5958a766.jpg";